export function CheckIcon() {
  return (
    <svg width="20.153" height="17.33" viewBox="0 0 20.153 17.33">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="사각형_48450"
            data-name="사각형 48450"
            width="20.153"
            height="17.33"
            transform="translate(0 0)"
            fill="#00c7c7"
          />
        </clipPath>
      </defs>
      <g id="그룹_21476" data-name="그룹 21476" clip-path="url(#clip-path)">
        <path
          id="패스_431"
          data-name="패스 431"
          d="M6.117,11.328c-.082-.173-.167-.342-.255-.506a54.267,54.267,0,0,0-3.357-4.6L0,9.564A25.033,25.033,0,0,1,3.66,14,27.277,27.277,0,0,1,4.888,17.33l2.754-1.114A44.356,44.356,0,0,1,10.58,8.973C14.727,1.836,20.153,0,20.153,0s-4.429.357-9.071,4.819a30.576,30.576,0,0,0-4.965,6.509"
          transform="translate(0 0)"
          fill="#00c7c7"
        />
      </g>
    </svg>
  );
}
